var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '../button';
import Icon from '../icon';
import Popover from '../popover';
import { Styled } from './style';
var ToggleView = /** @class */ (function (_super) {
    __extends(ToggleView, _super);
    function ToggleView(props) {
        var _this = _super.call(this, props) || this;
        _this.onToggleViewClick = function (active) {
            _this.props.onChange(active);
            _this.setState({ active: active });
        };
        _this.state = { active: _this.props.currentActive };
        return _this;
    }
    ToggleView.prototype.render = function () {
        var _this = this;
        return (React.createElement(Styled, { className: this.props.className },
            React.createElement(Popover, { inverted: true, trigger: React.createElement(Button, { icon: true, active: this.state.active === 'grid', onClick: function () { return _this.onToggleViewClick('grid'); } },
                    React.createElement(Icon, { name: "grid" })), content: React.createElement(FormattedMessage, { id: "ui_component.common.label.grid_view", defaultMessage: "Grid View" }), position: this.props.position ? this.props.position : 'top center' }),
            React.createElement(Popover, { inverted: true, trigger: React.createElement(Button, { icon: true, active: this.state.active === 'list', onClick: function () { return _this.onToggleViewClick('list'); } },
                    React.createElement(Icon, { name: "list" })), content: React.createElement(FormattedMessage, { id: "ui_component.common.label.list_view", defaultMessage: "List View" }), position: this.props.position ? this.props.position : 'top center' })));
    };
    return ToggleView;
}(React.Component));
export default ToggleView;
//# sourceMappingURL=index.js.map